import { GridColDef } from "@mui/x-data-grid";

export const columnsControlReport: GridColDef[] = [
  {
    field: "sample_reference",
    headerName: "Referencia muestra",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "client_reference",
    headerName: "Referencia Cliente",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "sample_type",
    headerName: "Tipo de muestra",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "analysis_type",
    headerName: "Análisis",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "isotope",
    headerName: "Isótopo",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "activity",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "uncertainty",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 100,
  },
];
